module.exports = "# Intro Video\n\nYouTube: BqXYz9nXWOM\n\n## Notes\nIntro to Popcorn Activity (1:47).\n\n# Instructions\n\n## Content\n\n### What brought you joy this week?\n* Think back to the experiences that brought you joy this week.\n* What were you doing?\n* Who were you with?\n* Get into partners, listen to their joys then share these with the class.\n\n## Notes\n\nPopcorn activity: Joys from the week.\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/30_classActivity/level2a_popcornJoys.md
// module id = 1849
// module chunks = 2